<template>
	<b-modal
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
		:title="'Create folder' | translate"
	>
		<form @submit.prevent="addFolder" class="modal-block">
			<input type="text" class="form-control mb-2" v-model="name" />
			<button class="btn btn-primary" :disabled="!name">
				{{ 'Create' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
export default {
	name: 'modal-folder',
	data: () => ({
		name: '',
	}),
	props: ['show'],
	computed: {
		folder() {
			const folder = this.$store.state.storage.folder
			return folder || undefined
		},
	},
	methods: {
		close() {
			this.$emit('close')
		},
		addFolder() {
			this.axios({
				method: 'post',
				url: 'storage/folders/',
				headers: {
					'Content-Type': 'application/json',
				},
				data: {
					name: this.name,
					parent: this.folder,
				},
			}).then(response => {
				// If folder created add it to folder`s list
				this.$store.commit('changeStorageFolders', [
					...this.$store.state.storage.folders,
					response.data,
				])
				this.$emit('close')
			})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:not(.close) {
	margin: 10px;
}
</style>
